import { defineMessages } from 'react-intl'

export const JobInfoHeaderMenuMessages = defineMessages({
  rename: {
    id: 'JobInfoHeaderMenuMessages.rename',
    description: 'Rename job kebab menu item on JobInfo page',
    defaultMessage: 'Rename Job',
  },
  renameModalTitle: {
    id: 'JobInfoHeaderMenuMessages.renameModalTitle',
    description: 'Title for rename job modal on JobInfo page',
    defaultMessage: 'Renaming job "{jobName}"',
  },
  renameLabel: {
    id: 'JobInfoHeaderMenuMessages.renameLabel',
    description:
      'Rename input field label for rename job modal  on JobInfo page',
    defaultMessage: 'New job name',
  },
  renameModalNotUniqueErrorMessage: {
    id: 'JobInfoHeaderMenuMessages.renameModalNotUniqueErrorMessage',
    description:
      'Error message for rename job modal if new name is not unique on JobInfo page',
    defaultMessage: 'Job name must be unique',
  },
  delete: {
    id: 'JobInfoHeaderMenuMessages.delete',
    description: 'Delete job kebab menu item on JobInfo page',
    defaultMessage: 'Delete Job',
  },
  deleteModalTitle: {
    id: 'JobInfoHeaderMenuMessages.deleteModalTitle',
    description: 'Title for confirm delete job modal on JobInfo page',
    defaultMessage: 'Delete Job',
  },
  deleteModalMessage: {
    id: 'JobInfoHeaderMenuMessages.deleteModalText',
    description: 'Message for confirm delete job modal on JobInfo page',
    defaultMessage:
      'Are you sure you want to remove job {jobName}?{br}This action cannot be undone!',
  },
  move: {
    id: 'JobInfoHeaderMenuMessages.move',
    description: 'Move job kebab menu item on JobInfo page',
    defaultMessage: 'Move Job',
  },
  moveModalTitle: {
    id: 'JobInfoHeaderMenuMessages.moveModalTitle',
    description: 'Title for confirm move job modal on JobInfo page',
    defaultMessage: 'Move Job "{jobName}"',
  },
  moveModalSave: {
    id: 'JobInfoHeaderMenuMessages.moveModalSave',
    description: 'Save button for move job modal on JobInfo page',
    defaultMessage: 'Save Changes',
  },
  selectLabel: {
    id: 'JobInfoHeaderMenuMessages.selectLabel',
    description: 'Label for group selects on move job modal',
    defaultMessage: 'Select target group',
  },
})
